// getFieldError retrives an error for the given field
import { Field } from '../components/Fields/types';

const getFieldError = (field: Field, errors?: Error[]) => errors?.find((error) => field.name === error.name);

export default getFieldError;
